// 日本語テーブル（機械翻訳・未校正 — ruling G4）。
// The Japanese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const ART_GONE = 'This art is too detailed for the size — enlarge it';
const BASE_PIECES = 'Parts on the tag sit too far apart to bridge a base — add a base margin, bring them closer, or shrink the art';
const INTERNAL = 'Something went wrong — try again';
const FATAL = 'Could not load the model builder — refresh the page';
const S = {
  title: "4層ネームタグ",
  cap: "文字の高さ（mm）",
  spacing: "文字間隔",
  textHint: "Enter で改行 · 最大3行",
  dir: {
    h: "横書き",
    v: "縦書き",
  },
  align: {
    h: {
      start: "左",
      center: "中央",
      end: "右",
    },
    v: {
      start: "上部",
      center: "中段",
      end: "下部",
    },
  },
  lineGap: "行間",
  layers: "カラーレイヤー",
  layerCount: "レイヤー数",
  base: "ベース",
  ring: "縁",
  textLayer: "文字",
  width: "幅",
  height: "厚さ",
  mm: " mm",
  looks: "カラーセット",
  loop: "キーホルダー穴",
  pos: {
    none: "なし",
    left: "左",
    right: "右",
    top: "上部",
  },
  hole: "穴の幅",
  ringW: "ループ縁",
  print: "プリント",
  layerHeight: "レイヤー高さ",
  mode: {
    multi: "マルチ（CFS/AMS）",
    swap: "単ノズル",
  },
  zTable: (color, z, layer) => `${z.toFixed(2)} mm（レイヤー ${layer}）で ${color} に替える`,
  size: (w, h, z) => `${w.toFixed(1)} × ${h.toFixed(1)} × ${z.toFixed(1)} mm`,
  dlstl: "STLを保存",
  copied: "コピーしました",
  stillBuilding: "生成中 — 長い複数行テキストには1分ほどかかることがあります",
  loadingFont: (got, total) => `フォントを読み込み中 ${got.toFixed(1)} / ${total.toFixed(1)} MB`,
  notice: {
    loadFailed: (family) => `${family} を読み込めません — 接続を確認 · 現在のフォントを使用`,
    capRaised: (family, cap) => `文字の高さを ${cap} mm にしました — ${family} で読める最小サイズです`,
  },
  issue: {
    "missing-glyph": (p) => `フォント ${String(p.font).replace(/@\d+$/, '')} にない文字: ${p.chars.join(' ')}`,
    "thin-ring": (p) => `${p.band + 1} 層目の縁が薄すぎます（${p.w} mm）— 0.8 mm 以上にしてください`,
    "thin-stroke": (p) => p.minCap
      ? `このフォントは ${p.minCap} mm から読めます — 文字の高さを最低 ${p.minCap} mm にしてください`
      : `${p.chars.join(' ')} の線が0.4 mmノズルより細い — 拡大するか太いフォントを選んでください`,
    "bed-fit": (p) => `タグは ${p.w.toFixed(0)} × ${p.h.toFixed(0)} mm — 220 mm のプリントベッドを超える可能性があります`,
    "loop-float": () => 'ループがタグにつながっていません — 移動するかベースマージンを増やしてください',
    "thin-art": () => 'アートの線の一部が0.4 mmノズルより細い — 拡大するか太い線のアートを選んでください',
    "icon-max": (p) => `アートの最大は ${p.max} mm です — そのサイズで表示しています`,
    "art-gone": () => 'アートがこのサイズに対して細かすぎます — 拡大してください',
    "base-pieces": () => 'タグ上のパーツが離れすぎてベースがつながりません — ベースマージンを増やすか近づけるかアートを縮小してください',
  },
  errorCode: {
    "build-timeout": "生成が2分で終わらず再開しました — 文字を減らすか別のフォントをお試しください",
    stale: "新しい変更が届きました",
    empty: "プリントする文字がありません",
    "font-load": "フォントが読み込めませんでした",
    internal: "問題が発生しました — もう一度お試しください",
    "base-pieces": "タグ上のパーツが離れすぎてベースがつながりません — ベースマージンを増やすか近づけるかアートを縮小してください",
    "art-gone": "アートがこのサイズに対して細かすぎます — 拡大してください",
    engine: "問題が発生しました — もう一度お試しください",
    fatal: "モデルビルダーを読み込めません — ページを再読み込みしてください",
  },
  fatal: "モデルビルダーを読み込めません — ページを再読み込みしてください",
  icon: "アートまたはロゴ（SVG）",
  unpick: "アートを削除",
  iconPos: {
    left: "左",
    right: "右",
    above: "上",
  },
  iconSize: "アートのサイズ",
  iconGap: "隙間",
  pct: (k) => `${Math.round(k * 100)}%`,
  needFile: "アートまたはロゴのSVGファイルを選んでください — 端末内に留まり、どこにも送信されません",
  artKept: "アートはこのタブ内にだけ存在します — 再読み込み後はファイルを再選択してください",
  keptOld: "（引き続き前のアートを使用）",
  thumb: "読み込んだアートのプレビュー",
  shareNoIcon: "このリンクにアートファイルは含まれません — 開く人がSVGを選ぶ必要があります",
  linkNeedsIcon: "このデザインはファイルのアートを使いますが、リンクには含まれません — SVGファイルを選んで追加してください",
  aboutP: "2–4色のネームタグやキーホルダーをデザインできます。タイ語・英語・中国語・日本語の名前を複数行または縦書きでプリントでき、フォントを選び、マルチカラー用に 3MF、1色用に STL をダウンロード。ブラウザで無料、インストール不要です。SVG ファイルのロゴやアイコンを名前の横に置けます — ファイルは端末から出ず、どこにも送信されません。",
};
export default S;
